import { call, put, takeLatest } from 'redux-saga/effects';
import { Users } from 'services/api';
import {
  sendConfirmationEmail,
  sendConfirmationEmailSuccess,
  sendConfirmationEmailFailure,
} from '../../actions';
import { actions as notificationActions } from 'components/Notification';

function* sendConfirmEmail({ payload }) {
  try {
    const { data } = yield call(Users.confirmationEmail, payload.id, {
      locale: payload.locale,
    });
    yield put(sendConfirmationEmailSuccess(data));
    yield put(
      notificationActions.addNotification([
        {
          type: 'success',
          message: { code: 'generated', resource: 'confirmation' },
        },
      ])
    );
  } catch (e) {
    yield put(sendConfirmationEmailFailure(e.data));
    yield put(
      notificationActions.addNotification(
        e.data.errors.map(error => ({ type: 'error', message: error.code }))
      )
    );
  }
}

export default () => takeLatest(sendConfirmationEmail, sendConfirmEmail);
